<template>

    <div class="img-list">

      <div v-show="imageShow" class="auth-image-box">
        <img class="auth-image margin-left-2" ref="targetImage" src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==">
        <img class="delete-button" @click="deleteSrc" src="@/assets/icon/sp-icon-delete-img.svg" alt=""/>
      </div>

      <div class="img-li-box" v-for="(item,key) in imgList" :key="key">
        <div class="img-li-b--url margin-left-2" style="background: #F7F7F2;border-radius: 8px;">
          <div style="font-family: 'Hiragino Kaku Gothic Pro'; font-style: normal; font-weight: 300; font-size: 12px; line-height: 18px; color: rgb(82, 82, 80);width: 168px;padding-top: 16px;padding-left: 52px;word-break: break-word;">
            {{ item.name }}
          </div>
        </div>
        <div class="img-li-b--delete">
          <img @click="handleFileRemove(item,key)" src="@/assets/icon/sp-icon-delete-img.svg" alt=""/>
        </div>
      </div>
      <div v-show="uploadMaxFlag" class="border-style">
        <el-col :span="24">
          <el-col class="el-col-padding-top">
            <img src="@/assets/icon/sp-icon-border.svg" class="img-style" alt="">
            <el-upload
              drag
              class="upload-size"
              accept="*"
              :limit="1"
              :auto-upload="false"
              :file-list="imgList"
              list-type="picture"
              :show-file-list="false"
              action=""
              :on-change="uploadOnChange"
              multiple>
              <el-col class="margin-top-el-col">
                <span class="span-text-size-color">
                  アップロードしたいファイルを、
                </span>
              </el-col>
              <el-col>
                <span class="span-text-size-color">
                  ここにドラック&ドロップしてください。
                </span>
              </el-col>
              <!-- <di class="el-upload__text text-size-color">アップロードしたいファイルをここにドラック</di> -->
            </el-upload>
          </el-col>

          <el-col class="el-padding-top">
            <!-- No.33横展开 -->
            <el-button
              class="glance-narrow-down my-button"
              @click="upload">
                <img
                  class="img-style-margin"
                  src="@/assets/icon/sp-icon-attached.svg"
                  alt=""/>
                <span class="span-color">
                  ファイルを添付する
                </span>
            </el-button>
          </el-col>
        </el-col>
      </div>

      <div class="img-li-b--upload" v-show="this.imgList !=0">
        <el-upload class="img-li-b--upl--field"
          accept="*"
          :limit="1"
          :auto-upload="false"
          :file-list="imgList"
          list-type="picture"
          :show-file-list="false"
          action=""
          :on-change="uploadOnChange">
        <el-button type="primary" v-show="this.isShow" ref="import"></el-button>
        </el-upload>
      </div>
    </div>
</template>

<script>

export default {
    name: 'indexSP',
    components:{
    },
    props: {
      imagesList: Object,
      src: String
    },
    data() {
      return {
        imageHeightAndWidth: true,
        width: null,
        height: null,
        validWidth: 1146,
        validHeight: 645,
        uploadMaxFlag: true,
        isShow: false,
        imageShow: true,
        imageSrc: null,
        portraitDeleteFlag: true,
        fileList: [
          {
            url: ""
          }
        ],
        imgList: [
          {
            url: '',
            name: ''
          }
        ],
        base64List:[],
      }
    },
    watch: {
      src (value) {
        this.imageSrc = value;
        if(this.imageSrc != null || this.imageSrc != undefined || this.imageSrc != "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==") {
          this.imageShow = true
          this.uploadMaxFlag = false
        }
      }
    },
    created() {
      this.imageSrc = this.src;
      this.imgList = []
    },
    mounted(){
      if(this.imagesList == null || this.imagesList == undefined){
        this.imgList = []
        this.imageShow = false
      }else{
        this.imgList.push(this.imagesList)
      }

    },
    methods: {

      uploadOnChange(file) {

        const isLt15M = file.size / 1024 / 1024 < 15;

        if (!isLt15M) {
          this.$messageIotError(this.$t("message.common.error.imageSizeError"));
          return this.imgList = []
        }

        this.uploadMaxFlag = false
        this.imgList.push(file)
        this.$emit('eventFile', this.imgList)
        this.imageShow = false

      },

    deleteSrc() {
      this.$msgbox({
        customClass: "delete-image-message-box",
        message: "この写真を削除しますよろしいですか？",
        showCancelButton: true,
        showClose: false,
        confirmButtonText: this.$t('button.common.ok'),
        cancelButtonText: this.$t('button.common.cancel')
      }).then(() => {
        this.imageSrc = null
        this.imageShow = false
        this.uploadMaxFlag = true
        this.$emit('deleteSrc', this.portraitDeleteFlag)
      }).catch((error) => {
        console.log(error)
      })
    },

    handleFileRemove(file, i) {
      this.$msgbox({
        customClass: "delete-image-message-box",
        message: "このファイルを削除しますよろしいですか？",
        showCancelButton: true,
        showClose: false,
        confirmButtonText: this.$t('button.common.ok'),
        cancelButtonText: this.$t('button.common.cancel')
      }).then(() => {
        this.imgList.splice(i, 1)
        this.uploadMaxFlag = true
        if(this.imageSrc != null && this.imageSrc != undefined && this.imageSrc != "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==") {
          this.imageShow = true
        }
        this.$emit('deleteFile', this.imgList)
      }).catch((error) => {
        console.log(error)
      })
    },

    upload() {
      this.$refs.import.$el.click()
    }
  }
}
</script>

<style lang="scss" scoped>

.img-list {
  // overflow: hidden;
  width: 528px;

  // 文件列表
  .img-li-box {
    text-align: left;
    position: relative;
    display: table-cell;
    width: 213px;
    height: 100%;
    margin: 5px 20px 20px 0;
    border-radius: 4px;
    transition: all .3s;

  // 图片
  .img-li-b--url {
    display: block;
    width: 213px;
    height: 213px;
    margin: 0 auto;
    border-radius: 4px;
  }

    // 删除按钮
  .img-li-b--delete {
    margin-bottom: 160px;
    position: absolute;
    bottom: 10px;
    right: 10px;
    color: #8492a6;
    img {
      cursor: pointer;
      &:hover {
        opacity: 0.6;
      }
    }
  }

  // 底部
  .img-li-b--bottom {
    margin-top: 10px;
  }

  //   .img-li-b--delete,
  //   .img-li-b--layer {
  //     opacity: 0;
  //     transition: all .3s;
  //   }

  // &:hover {
  //   .img-li-b--delete,
  //   .img-li-b--layer {
  //     opacity: 1;
  //   }
  // }

    // 上传进度
    &.img-li-b--progress {
    text-align: center;
    padding-top: 50px;
    }

  }
    // 上传按钮
    .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: none;
    text-align: center;

    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }

.border-style{
  margin-top: 12px;
  width: 528px;
  background-color: #F7F7F2;
  border: 0;
  border-radius: 6px;
  border-width: 2px;
  height: 279px;
}

.add {
  background-color: #2699FB;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  }

.information-title {
  cursor: pointer;
  }

.el-padding-top {
  padding-top: 28px;
  /* 按钮与图片上传区域左对齐 */
  padding-left: 24px;
}

.el-col-padding-top {
  padding: 0;
  height: 158px;
  margin: 24px 24px 0px 24px;
  width: 480px;
  }

.text-button-size-color {
  font-size: 18px;
  color:#525250;
  margin-left: 20px;
}

.text-size-color {
  font-size: 18px;
  color: #525250;
  }
}
::v-deep .el-upload-dragger {
  background-color: transparent;
  border: none;
  height: 60px;
}

.img-style {
  position: absolute
}

::v-deep .el-upload-dragger{
  height: 158px;
  width: 480px;
}

.span-text-size-color {
  font-size: 12px;
  opacity: 0.5;
  color: #525250 !important;
}

.margin-top-el-col {
  margin-top: 50px;
}

.glance-narrow-down {
  width: 146px;
  height: 40px;
  line-height: 18px;
  text-align: center;
  padding: 0;
  color:#525250;
  font-size: 13px;
  background-color: #f7f7f2 !important;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
}

// No.33横展开
::v-deep .glance-narrow-down span{
   display: flex;
  align-items: center;
  justify-content: center;
}

.my-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color: #525250;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.3s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  font-size: 13px;
  border-radius: 8px;
  width: 188px;
  height: 40px;
  background-color: #f2f2ed;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
    4px 4px 4px #e6e6e1;
  &:focus,
  &:hover {
    border-radius: 8px;
    transition: all .3s;
    background-color: rgba(0, 0, 0, 0.04);
    color: rgba(82, 82, 80, 0.6);
  }
}

.margin-top-img {
  margin-top: -9px;
}

::v-deep .el-upload > .is-dragover {
  border: 0 !important;
}

.auth-image-box{
  width: 213px;
  height: 213px;
  .auth-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

  // 删除按钮
.delete-button {
  margin-top: -220px;
  position: absolute;
  margin-left: 190px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
}

.span-color {
  color: #525250;
  padding-left: 20px;
}

::v-deep .glance-narrow-down {
  opacity: 1;
}
.glance-narrow-down:hover {
  opacity: 0.6;
}
.img-style-margin {
  position: absolute;
  margin-left: -128px;
}
</style>
